module.exports = __webpack_public_path__ + "static/media/Resistance_is_futile.5004d1ec.mp3";